import React from "react";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";



const SwiperCarousel = ({ images }) => {
  return (
    <Swiper
      className="carousel-container"
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={20}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop
      style={{ width: "90vw", maxWidth: "1000px", margin: "auto" }}
    >
      {images.map((img, idx) => (
        <SwiperSlide key={idx}>
          <div
            style={{
              width: "100%",
              aspectRatio: `${img.width} / ${img.height}`,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              src={img.path}
              alt={img.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
          <div style={{ textAlign: "center", marginTop: 8, fontWeight: "600" }}>
            {img.name}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperCarousel;